module.exports = __webpack_public_path__ + "static/media/pin.a57da45f.svg";